import { render } from "./UploadDocumentFrontDesktopView.vue?vue&type=template&id=70a2e2a6&scoped=true&ts=true"
import script from "./UploadDocumentFrontDesktopView.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentFrontDesktopView.vue?vue&type=script&lang=ts"

import "./UploadDocumentFrontDesktopView.vue?vue&type=style&index=0&id=70a2e2a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a2e2a6"]])

export default __exports__